(function (appName) {
    RCDPW.Angular.setAppName(appName);
    RCDPW.Angular.buildModule('services')
        .factory('dpwCommunityService', ['$q', 'api', function ($q, api) {
            return {
                getAnswerHubPosts: function () {
                    return $q(function (resolve, reject) {
                        return api.call(api.community.getAnswerHubPosts(), function (res) {
                            resolve(_.get(res, 'posts.list', []));
                        }, function (err, defaultHandler) {
                            reject({
                                err: err,
                                defaultHandler: defaultHandler
                            });
                        });
                    });
                }
            };
        }]);
    RCDPW.Angular.buildModule('main')
        .component('dpwCommunity', {
            templateUrl: 'dpw-community.html',
            controller: ['mixpanelService', function (mixpanelService) {
                var self = this;
                self.mixpanelService = mixpanelService;

                self.pageTexts = {
                    heroHeader: 'Community'
                };
            }]
        })
        .component('dpwCommunityBlog', {
            templateUrl: 'dpw-community-blog.html',
            controller: ['api', 'mixpanelService', function (api, mixpanelService) {
                var self = this;
                self.mixpanelService = mixpanelService;

                api.call(api.community.getBlogPosts(), function (res) {
                    self.posts = res.posts;
                }, function () {
                    self.fetchDataFailed = true;
                    self.unexpectedErrorMsg = RCDPW.Lang.UNEXPECTED_ERROR;
                });
            }]
        })
        .component('dpwCommunityForum', {
            templateUrl: 'dpw-community-forum.html',
            controller: ['dpwCommunityService', 'helpers', 'mixpanelService', function (dpwCommunityService, helpers, mixpanelService) {
                var self = this;
                self.mixpanelService = mixpanelService;

                self.goToCommunityUrl = helpers.getGoToEngageCommunityUrl();

                self.getTimeFrom = function (dateString) {
                    return moment().from(
                        moment(new Date(dateString), 'YYYY/MM/DD HH:mm:ss Z'),
                        true
                    );
                };
                self.getPostExcerpt = function (content) {
                    content = (content||'')
                        .replace(/<a.*?>/g, '')
                        .replace(/<\/a>/g, '')
                        .replace(/<script.*?\/?>/g, '')
                        .replace(/<\/script>/g, '')
                        .replace(/<img.*?\/?>/g, '')
                        .replace(/&nbsp;/g, ' ');
                    var divEl = document.createElement('div');
                    divEl.innerHTML = content;
                    var result = divEl.innerText;
                    $(divEl).remove();
                    return result;
                };
                self.getPostStyle = function (style) {
                    return _.capitalize(style);
                };
                dpwCommunityService.getAnswerHubPosts().then(function (posts) {
                    self.posts = posts;
                }).catch(function () {
                    self.fetchDataFailed = true;
                    self.unexpectedErrorMsg = RCDPW.Lang.UNEXPECTED_ERROR;
                });
            }]
        })
        .component('dpwCommunityUpcomingEvents', {
            templateUrl: 'dpw-community-upcoming-events.html',
            controller: ['developerEventsService', 'mixpanelService', function (developerEventsService, mixpanelService) {
                var self = this;

                self.allEventsLink = RCDPW.entries.engage.developerEvents.href;
                self.mixpanelService = mixpanelService;

                developerEventsService.getAllEvents({noLoading: true})
                    .then(function (events) {
                        events = events.filter(function (event) {
                            return !event.isPostEvent;
                        });
                        self.events = events.length > 3 ?
                            events.slice(events.length - 3, events.length) :
                            events;
                        self.events = self.events.sort(function (a, b) {
                            return moment(a.startDate).diff(b.startDate);
                        });
                    })
                    .catch(function () {
                        self.fetchDataFailed = true;
                        self.unexpectedErrorMsg = RCDPW.Lang.UNEXPECTED_ERROR;
                    });
            }]
        });

})(RCDPW.moduleNames.COMMUNITY);
